/**
 * ns.wow Notes
 * Facade class for public accessible core functionality.
 */


class Plugin {


  static init() {

    // Replace fake links with A-tags and REST calls

    const linkItems = document.querySelectorAll( "a" );

    linkItems.forEach( ( element ) => {
        if ( element.href ) {
          const url = new URL( element.href );
          if ( url.host === 'note.link' ) {
            const path = url.pathname.replace( /^\/+|\/+$/g, '' ); // trim leading and trailing slash
            const pathFragments = path.split( '/' );
            // Check if link format is valid: https://note.link/category/{categorySlug}/?note={noteNumber}
            if ( pathFragments.length == 2 && pathFragments[0] === "category" && pathFragments[1] && url.searchParams.has( "note" ) ) {
              let noteLinkId = url.searchParams.get( "note" );
              if ( noteLinkId ) {
                let notes = [{ id: noteLinkId, title: element.innerHTML.trim() }];
                let separator = '';
                let category = pathFragments[1];
                Plugin.createLink( element, category, notes, separator );
              } else {
                console.log( "invalid note id: " + noteLinkId );
              }
            } else {
              console.log( "invalid link format: expected 'note://category/{categorySlug}/?note={noteNumber}'" );
            }
          }
        }
      }
    );

    // Replace note table spans with A-tags and REST calls

    const tableItems = document.querySelectorAll(NSContext.plugins.notes.noteSelector);

    tableItems.forEach( ( element ) => {
        let notes = [];
        let separator = ' ';
        let category = NSContext.plugins.notes.matchedCategory;
        let html = element.innerHTML.trim();
        let noteNumber = Plugin.getNoteId( html );
        // Hide element for invalid notes (for backwards compatibility)
        if ( noteNumber === '&nbsp;' ) {
          element.style.display = "none";
          return; // continue
        } else if ( noteNumber === 'Note' ) {
          return; // continue
        }
        // There can be multiple notes in a table row, delimited by "/" or ","
        if ( html.indexOf( '/' ) !== -1 ) {
          separator = '/';
          let entries = html.split( '/' );
          for (let i = 0; i < entries.length; i++) {
            notes.push({id: entries[i].trim(), title: entries[i].trim()});
          }
        } else {
          separator = ',';
          let entries = html.split( ',' );
          for (let i = 0; i < entries.length; i++) {
            notes.push({id: entries[i].trim(), title: entries[i].trim()});
          }
        }
        Plugin.createLink( element, category, notes, separator );
      }
    );

    // Add popup box to show the linked notes

    document.body.insertAdjacentHTML( 'beforeend', `<div class="nhsnote-box">
			<div class="nhsnote-box__background js-nhsnote-box-close"></div>
			<div class="nhsnote-box__inner js-nhsnote-box-inner">
				<button class="nhsnote-box__close js-nhsnote-box-close"></button>
				<div class="nhsnote-box__content js-nhsnote-box-content"></div>
			</div>
		</div>` );

    // Click event for opening the popup box

    const linkElements = document.querySelectorAll("." + NSContext.plugins.notes.noteLinkClass);

    linkElements.forEach( (element) => {
        element.addEventListener("click", (event) => {
          Plugin.openPopup(event.target);
          return false;
        });
      }
    );

    // Click event for closing the popup box (2 Events, close button (X) and background around dialog)

    const popupBoxClose = document.querySelectorAll('.js-nhsnote-box-close')

    popupBoxClose.forEach( (element) => {
        element.addEventListener("click", (event) => {
          Plugin.closePopup( event.target);
        });
      }
    );

  }


  static createLink(element, category, notes, separator) {

    let modalClass = '';

    const language = document.documentElement.lang.substring(0,2);

    if (element.hasAttribute('data-modal-class')) {
      modalClass = element.getAttribute('data-modal-class');
    }

    // Create link to REST target
    let resolvedNotes = [];

    for ( let i = 0; i < notes.length; i++ ) {
      let noteId = notes[i].id;
      let noteTitle = notes[i].title;
      // ns.wow 1 encoding, not sure if we still need that
      noteId = noteId.replace(/\u00e4/g, "ae").replace(/\u00fc/g, "ue").replace(/\u00f6/g, "oe");
      const url = NSContext.site.restUrl + 'public/notes' + "?term_id=" + category + "&note=" + noteId + "&class=" + modalClass + "&lang=" + language;
      resolvedNotes.push('<a data-href="' + url + '" class="' + NSContext.plugins.notes.noteLinkClass + '">' + noteTitle + '</a>');
    }

    // Replace element with new HTML
    resolvedNotes = resolvedNotes.join(separator);
    element.outerHTML = resolvedNotes;
    document.dispatchEvent(new Event("noteLinksAdded"));
  }


  static getNoteId(string) {
    let output = '';
    output = string.replace(".", "\\.");
    // Remove brackets
    output = output.replace("(", "");
    output = output.replace(")", "");
    // Remove leading zeros
    output = output.replace(/^0+/, "");
    return output;
  }


  static openPopup(element) {

    const popupBox = document.querySelector('.nhsnote-box');
    const popupInner = popupBox.querySelector('.js-nhsnote-box-inner');
    const popupContent = popupBox.querySelector('.js-nhsnote-box-content');

    popupBox.style.display = "block";

    fetch(element.getAttribute('data-href'),
      {
        method: 'GET',
        headers: {'X-WP-Token': NSContext.token},
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        let html = "";
        // Check for WP error
        if (data.hasOwnProperty('code')) {
          if (data.code == 'rest_missing_access_token' || data.code == 'rest_invalid_access_token') {
            html += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.reload + '</h2>';
          } else {
            html += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.notfound + '</h2>';
            html += '<p class="nhsnote__debug_hint">' + NSContext.plugins.notes.texts.hint + '</p>';
            if (NSContext.plugins.notes.debug) {
              html += '<div class="nhsnote__debug_box">';
              html += '<p class="nhsnote__debug_box_title"><strong>Error: </strong>' + data.code +'</p>';
              html += '<p class="nhsnote__debug_box_text"><strong>Message: </strong>' + data.message + '</p>';
              html += '</div>';
            }
          }
          console.error(data);
        } else {
          html = data.content;
        }
        popupBox.classList.add('nhsnote-box--loaded');
        popupContent.innerHTML = html;
        popupInner.style.display = "block";
        document.dispatchEvent(new Event("noteLoaded"));
        window.dispatchEvent(new Event('resize'));
        document.querySelector('body').classList.add('notes-open');
      })
      .catch(function (err) {
        console.warn('Error fetching note', err);
      });

  }


  static closePopup(element) {

    const popupBox = document.querySelector('.nhsnote-box');
    const popupInner = popupBox.querySelector('.js-nhsnote-box-inner');
    const popupContent = popupBox.querySelector('.js-nhsnote-box-content');

    document.querySelector('body').classList.remove('notes-open');

    popupContent.innerHTML = "";
    popupBox.classList.remove('nhsnote-box--loaded');
    popupInner.style.display = "none";
    popupBox.style.display = "none";

    document.dispatchEvent(new Event("noteClosed"));

  }


}

export default Plugin;
